export function getImageMapConfigurationOption(key) {
  const options = {
    'image-max-weight': 10485760, // 10 Mo in octets
    'image-min-width': 1040,
    'image-allowed-types': ['image/jpeg', 'image/png'],
    'image-alt-text-length': 400,
    'zone-title-max-length': 50,
    'zone-text-max-length': 400,
    'zone-url-max-length': 1000,
    'zone-coord-max-length': 4,
  };
  if (options[key] != undefined) {
    return options[key];
  }
  return null;
}
